import { CACHE_TIERS } from "@workspace/types";
import { trpc } from "@/lib/trpc/react";

/**
 * Hook to fetch related festivals (different years/weekends) for a festival
 * Now uses tRPC for type-safe, server-side data fetching
 */
export function useRelatedFestivals(
	festivalId: string | null,
): ReturnType<typeof trpc.festival.getRelatedFestivals.useQuery> {
	return trpc.festival.getRelatedFestivals.useQuery(
		{ festivalId: festivalId! },
		{
			enabled: !!festivalId,
			...CACHE_TIERS.DYNAMIC, // 5 minutes
		},
	);
}
